module.exports = __webpack_public_path__ + "static/media/LATINS_cuisine-3.28a8bab6.jpg";